import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { AxiosPromise, AxiosRequestConfig } from 'axios';

import { api } from '@/api';

export async function getDespatchJobs(
  params: openapi.DespatchJobsQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.DespatchJobsContentOpenapi> {
  return await api.get<openapi.DespatchJobsContentOpenapi>('/despatch/jobs/', {
    ...requestConfig,
    params,
  });
}

export async function putDespatchJobStopTimestamps(
  params: openapi.PutDespatchJobStopTimestamps_Query,
  data: openapi.PutDespatchJobStopTimestamps_Body,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.PutDespatchJobStopTimestamps_200> {
  return await api.put<openapi.PutDespatchJobStopTimestamps_200>(
    '/despatch/job/stop/timestamps/',
    data,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function postDespatchJobUndoAll(
  params: openapi.PostDespatchJobUndoAll_Query,
  data?: openapi.PostDespatchJobUndoAll_Body,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.PostDespatchJobUndoAll_200> {
  return await api.post<openapi.PostDespatchJobUndoAll_200>(
    '/despatch/job/undo_all/',
    data,
    {
      ...requestConfig,
      params,
    },
  );
}
